import React from 'react'
import { graphql } from 'gatsby'

// Components
import CollectionPage from './CollectionPage'

const CollectionIndex = (props) => {
  // console.log('👾 index > ', props)

  return <CollectionPage {...props} />
}

export default CollectionIndex

export const collectionQuery = graphql`
  query CollectionQuery($handle: String) {
    collection: shopifyCollection(handle: { eq: $handle }) {
      ...Collection
      image {
        altText
        imgixImage {
          gatsbyImageData(width: 1440, imgixParams: { auto: "format, compress" })
        }
      }
      products {
        ...Product
        ...Variants
        ...ProductReviews
        featuredImage {
          imgixImage {
            gatsbyImageData(width: 360, imgixParams: { auto: "format, compress" })
          }
          originalSrc
        }
      }
    }
    ...SiteConfig
  }
`
